import styled from 'styled-components';

// TODO - Replace with Container component from Mews Design System
export const PaymentInputContainer = (component: React.ComponentType) => styled(component)`
    height: 38px;
    width: 100%;
`;
